"use client";

import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, ItemAvatar, ItemContent, ItemTitle, QuantityInput, TableCell, TableRow, tableRowSizeVariants, UnstyledButton, useTable } from "@opensea/ui-kit";
import { Close } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { TRANSFER_FLOW_FORM_ITEM_CLASSNAMES } from "./constants";
import { TransferFlowFormItemFragment } from "./TransferFlowFormItem.fragment";
export const TransferFlowFormItem = t0 => {
  const $ = _c(52);
  const {
    item: itemKey,
    index
  } = t0;
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      keyName: "_id",
      control,
      name: "items"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fields,
    remove
  } = useFieldArray(t1);
  let t2;
  if ($[2] !== itemKey) {
    t2 = readFragment(TransferFlowFormItemFragment, itemKey);
    $[2] = itemKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const item = t2;
  const {
    size
  } = useTable();
  let T0;
  let T1;
  let T2;
  let T3;
  let ownedQuantity;
  let showQuantityInput;
  let t3;
  let t4;
  let t5;
  if ($[4] !== item.ownership?.quantity || $[5] !== item.standard || $[6] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    showQuantityInput = item.standard === "ERC1155";
    ownedQuantity = item.ownership?.quantity ?? "0";
    T3 = TableRow;
    T2 = TableCell;
    t5 = TRANSFER_FLOW_FORM_ITEM_CLASSNAMES.item;
    T1 = Item;
    t4 = "unstyled";
    T0 = ItemAvatar;
    t3 = image();
    $[4] = item.ownership?.quantity;
    $[5] = item.standard;
    $[6] = size;
    $[7] = T0;
    $[8] = T1;
    $[9] = T2;
    $[10] = T3;
    $[11] = ownedQuantity;
    $[12] = showQuantityInput;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    T0 = $[7];
    T1 = $[8];
    T2 = $[9];
    T3 = $[10];
    ownedQuantity = $[11];
    showQuantityInput = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
  }
  let t6;
  if ($[16] !== T0 || $[17] !== item.imageUrl || $[18] !== t3) {
    t6 = <T0 className={t3} src={item.imageUrl} />;
    $[16] = T0;
    $[17] = item.imageUrl;
    $[18] = t3;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== item.name) {
    t7 = <ItemTitle>{item.name}</ItemTitle>;
    $[20] = item.name;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== item.collection) {
    t8 = item.collection ? <CollectionLockup collection={item.collection} size="xs"><CollectionLockupContent><CollectionLockupTitle /></CollectionLockupContent></CollectionLockup> : null;
    $[22] = item.collection;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <ItemContent>{t7}{t8}</ItemContent>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== T1 || $[28] !== t4 || $[29] !== t6 || $[30] !== t9) {
    t10 = <T1 variant={t4}>{t6}{t9}</T1>;
    $[27] = T1;
    $[28] = t4;
    $[29] = t6;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== T2 || $[33] !== t10 || $[34] !== t5) {
    t11 = <T2 className={t5}>{t10}</T2>;
    $[32] = T2;
    $[33] = t10;
    $[34] = t5;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== control || $[37] !== index || $[38] !== ownedQuantity || $[39] !== showQuantityInput) {
    t12 = showQuantityInput && <Controller control={control} name={`items.${index}.quantity`} render={t13 => {
      const {
        field,
        fieldState
      } = t13;
      return <QuantityInput error={Boolean(fieldState.error?.message)} max={bn(ownedQuantity).toNumber()} onValueChange={value => {
        field.onChange(value);
      }} placeholder={ownedQuantity} value={field.value} />;
    }} />;
    $[36] = control;
    $[37] = index;
    $[38] = ownedQuantity;
    $[39] = showQuantityInput;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== fields.length || $[42] !== index || $[43] !== remove) {
    t13 = fields.length > 1 && <UnstyledButton onClick={() => {
      remove(index);
    }}><Close fill="interactive-primary-styles" /></UnstyledButton>;
    $[41] = fields.length;
    $[42] = index;
    $[43] = remove;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t12 || $[46] !== t13) {
    t14 = <TableCell className={TRANSFER_FLOW_FORM_ITEM_CLASSNAMES.actions}>{t12}{t13}</TableCell>;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== T3 || $[49] !== t11 || $[50] !== t14) {
    t15 = <T3>{t11}{t14}</T3>;
    $[48] = T3;
    $[49] = t11;
    $[50] = t14;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  return t15;
};